// App-wide actions

export const ACTION_LOGOUT = 'logout';

export function logout() {
  return {
    type: ACTION_LOGOUT,
    payload: {},
  };
}
